import { createContext } from "@pharaday/utils";
import type { VariantProps } from "class-variance-authority";
import type { Dispatch, RefObject, SetStateAction } from "react";

import type { AllowedInputTypes } from "./Root";
import type { inputVariants } from "./style";

export type OTPRootContext = {
  type?: AllowedInputTypes;
  inputRefs: RefObject<(HTMLInputElement | null)[]>;
  onChange: (otp: string) => void;
  isInvalid: boolean;
  disabled: boolean;
  activeInput: number;
  setActiveInput: Dispatch<SetStateAction<number>>;
  value?: string;
} & VariantProps<typeof inputVariants>;

const [useOTPRootContext, OTPRootContextProvider] = createContext<OTPRootContext>();

export { OTPRootContextProvider, useOTPRootContext };
